import { Alert } from "antd";
import React, { useContext, useEffect, useState } from "react";
import FullScreenLayout from "../../layouts/FullScreenLayout";
import { Actions } from "../Store/Reducer";
import { StoreContext } from "../Store/Store";
import axios from "axios";

export const loadVarsJson = async ({ setIsError }) => {
  let result;
  try {
    const response = await axios(`/vars.json?t=${Date.now()}`);
    if (!response.data.Mqtt) throw new Error("Load vars error.");
    result = response.data;
  } catch (error) {
    if (setIsError) setIsError(error.message);
  }
  return result;
};

function delay(time) {
  return new Promise((resolve) => setTimeout(resolve, time));
}

const VarsProvider = ({ children }) => {
  const [store, dispatch] = useContext(StoreContext);
  const setIsError = (error) =>
    dispatch({ type: Actions.SetVarsError, payload: error });

  // load vars.json
  const [vars, setVars] = useState({});
  const [reloadVars, setReloadVars] = useState(null);
  useEffect(() => {
    (async () => {
      let config = await loadVarsJson({ setIsError });
      if (JSON.stringify(config) !== JSON.stringify(vars)) {
        if (Object.keys(vars).length === 0) {
          // first load, set vars
          setVars(config);
          dispatch({ type: Actions.SetVars, payload: config });
        } else {
          // not first load, vars changed, reload page
          window.location.reload();
        }
      }
      await delay(60 * 1000); // reload every 1 minutes
      setReloadVars(Date.now());
    })();
  }, [reloadVars]);

  let contents = children;
  if (store.vars === null) {
    contents = (
      <FullScreenLayout>
        <div></div>
      </FullScreenLayout>
    );
  }
  if (store.varsError) {
    contents = (
      <FullScreenLayout>
        <Alert message={store.varsError} type="error" showIcon />
      </FullScreenLayout>
    );
  }
  return <div>{contents}</div>;
};

export default VarsProvider;
